function $2dbda2f873e4581c$export$2e2bcd8739ae039() {
    const ageEl = document.querySelector('[data-age]');
    const birth = new Date(1989, 6, 18); // month is 0-indexed
    const now = new Date();
    let age = now.getFullYear() - birth.getFullYear();
    const hasBirthdayPassed = now.getMonth() > birth.getMonth() || now.getMonth() === birth.getMonth() && now.getDate() >= birth.getDate();
    if (!hasBirthdayPassed) age--;
    const postFix = ageEl.getAttribute('data-postfix');
    ageEl.textContent = String(age) + postFix;
}


function $7f912d45249a01c8$export$2e2bcd8739ae039() {
    document.querySelectorAll('[data-publication]').forEach($7f912d45249a01c8$var$initPublicationThumbnail);
}
/**
 * @param {Element} el
 */ function $7f912d45249a01c8$var$initPublicationThumbnail(el) {
    const toggleEl = el.querySelector('[data-publication-toggle]');
    const activeClass = el.getAttribute('data-publication-active-class');
    const metaEl = el.querySelector('[data-publication-meta]');
    const activeToggleContent = toggleEl.getAttribute('data-publication-toggle-active-content');
    const initialToggleContent = toggleEl.innerHTML;
    toggleEl.addEventListener('click', ()=>{
        if (!metaEl.classList.contains(activeClass)) {
            metaEl.classList.add(activeClass);
            toggleEl.innerHTML = activeToggleContent;
            return;
        }
        metaEl.classList.remove(activeClass);
        toggleEl.innerHTML = initialToggleContent;
    });
}


(0, $2dbda2f873e4581c$export$2e2bcd8739ae039)();
(0, $7f912d45249a01c8$export$2e2bcd8739ae039)();


//# sourceMappingURL=repo.a98f0bb1.js.map
